import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-040ba16c")

_pushScopeId("data-v-040ba16c")
const _hoisted_1 = { class: "terms-card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "terms-title" }, "利用規約", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_logo = _resolveComponent("logo")
  const _component_Terms = _resolveComponent("Terms")
  const _component_el_card = _resolveComponent("el-card")
  const _component_wrapper = _resolveComponent("wrapper")

  return (_openBlock(), _createBlock(_component_wrapper, { class: "wrapper" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_logo),
        _hoisted_2,
        _createVNode(_component_el_card, {
          class: "terms",
          "body-style": { padding: '30px' }
        }, {
          default: _withId(() => [
            _createVNode(_component_Terms)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
})